import React from 'react'
import { useSelector } from 'react-redux'
import {
    resetQuantityFrom,
    resetQuantityTo,
    selectQuantityFrom,
    selectQuantityTo,
    setQuantityFrom,
    setQuantityTo,
    initialState
} from '../filterSlice'
import Slider from '../base/Slider'

const Quantity = () => {
    const quantityFrom = useSelector(selectQuantityFrom)
    const quantityTo = useSelector(selectQuantityTo)

    return (
        <Slider
            name={'Наличие, шт.'}
            from={quantityFrom}
            to={quantityTo}
            min={initialState.quantityFrom}
            max={initialState.quantityTo}
            actionFrom={setQuantityFrom}
            actionTo={setQuantityTo}
            actionResetFrom={resetQuantityFrom}
            actionResetTo={resetQuantityTo}
        />
    )
}

export default Quantity
